import React, { useState } from "react";
import "./navigation.css";
import personGrey from "./icons/person-grey.png";
import personWhite from "./icons/person-white.png";
import resumeGrey from "./icons/resume-grey.png";
import resumeWhite from "./icons/resume-white.png";
import projectGrey from "./icons/project-grey.png";
import projectWhite from "./icons/project-white.png";
import coursesWhite from "./icons/courseWhite.png";
import coursesGrey from "./icons/courseGrey.png";
import contactGrey from "./icons/contact-grey.png";
import contactWhite from "./icons/contact-white.png";
import { Link, useLocation } from "react-router-dom";
export default function Navigation() {
  const currentRoute = useLocation().pathname;
  const [person, setPerson] = useState(personGrey);
  const [resume, setResume] = useState(resumeGrey);
  const [project, setProject] = useState(projectGrey);
  const [courses, setCourses] = useState(coursesGrey);
  const [contact, setContact] = useState(contactGrey);
  return (
    <div className="navigationContainer">
      <Link
        to="/"
        onMouseEnter={(e) => setPerson(personWhite)}
        onMouseLeave={(e) => setPerson(personGrey)}
      >
        <div className={currentRoute === "/" ? "active " : "navigationSection"}>
          <div>
            <img
              src={currentRoute === "/" ? personWhite : person}
              alt="person grey"
            />
          </div>
          <span>About</span>
        </div>
      </Link>
      <Link
        to="resume"
        onMouseEnter={(e) => setResume(resumeWhite)}
        onMouseLeave={(e) => setResume(resumeGrey)}
      >
        <div
          className={
            currentRoute === "/resume" ? "active " : "navigationSection"
          }
        >
          <div>
            <img
              src={currentRoute === "/resume" ? resumeWhite : resume}
              alt="resume icon"
            />
          </div>
          <span>Resume</span>
        </div>
      </Link>

      <Link
        to="projects"
        onMouseEnter={(e) => setProject(projectWhite)}
        onMouseLeave={(e) => setProject(projectGrey)}
      >
        <div
          className={
            currentRoute === "/projects" ? "active " : "navigationSection"
          }
        >
          <div>
            <img
              src={currentRoute === "/projects" ? projectWhite : project}
              alt="project icon"
            />
          </div>
          <span>Projects</span>
        </div>
      </Link>
      <Link
        to="courses"
        onMouseEnter={(e) => setCourses(coursesWhite)}
        onMouseLeave={(e) => setCourses(coursesGrey)}
      >
        <div
          className={
            currentRoute === "/courses" ? "active " : "navigationSection"
          }
        >
          <div>
            <img
              src={currentRoute === "/courses" ? coursesWhite : courses}
              alt="courses icon"
            />
          </div>
          <span>Courses</span>
        </div>
      </Link>
      <Link
        to="contact"
        onMouseEnter={(e) => setContact(contactWhite)}
        onMouseLeave={(e) => setContact(contactGrey)}
      >
        <div
          className={
            currentRoute === "/contact" ? "active " : "navigationSection"
          }
        >
          <div>
            <img
              src={currentRoute === "/contact" ? contactWhite : contact}
              alt="contact icon"
            />
          </div>
          <span>Contact</span>
        </div>
      </Link>
    </div>
  );
}
